/**
 * Resolver endpoint when the caller is content with the canonical Assets
 * workspace (no product context, no Units topology lookup). Returns
 * `WorkspaceLatestResponse { linkedAssetsWorkspaceId, siteWithJiraUrl? }`.
 *
 * Override at call-sites (e.g. for `perms-picker.jira-dev.com`) via the
 * `endpoint` option on `fetchAssetsWorkspaceHost`.
 */
export const ASSETS_WORKSPACE_RESOLVER_URL = '/assets/workspace';

/**
 * Resolver endpoint when the caller wants the workspace scoped to a specific
 * product context (jira / jsm / confluence). Append `?productContext=<value>`
 * at the request site.
 */
export const ASSETS_INTERNAL_WORKSPACE_RESOLVER_URL = '/assets/internal/workspace';

/**
 * Allowed values for the `productContext` query parameter on the
 * `/internal/workspace` endpoint.
 */
export const PRODUCT_CONTEXTS = {
	JIRA: 'jira',
	JSM: 'jsm',
	CONF: 'confluence',
} as const;
export type ProductContext = (typeof PRODUCT_CONTEXTS)[keyof typeof PRODUCT_CONTEXTS];

/** Default product context when callers don't specify one. */
export const DEFAULT_PRODUCT_CONTEXT: ProductContext = PRODUCT_CONTEXTS.JSM;

/**
 * Feature gate that controls the entire codepath. When OFF, the hook returns
 * `status: 'unavailable'` and never makes a network call.
 */
export const ASSETS_WORKSPACE_HOST_FG = 'astral_units_workspace_host_resolver';

/**
 * Soft cache TTL. After this, the next subscriber triggers a background
 * refetch but still receives the previously-cached value optimistically.
 *
 * 15 minutes balances freshness (Units topology can change) against API
 * load (the resolver endpoint is intentionally heavy on the BE side).
 */
export const ASSETS_WORKSPACE_HOST_TTL_MS: number = 15 * 60 * 1000;
